package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.series_tab.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card_detail.LoyaltyCardDetail
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.series_tab.getCustomerCardSeriesBorderColor
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun ResetBooking(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    resetBookingLoading: Boolean,
    resetRangeLoyaltyCard: (Int, Int) -> Unit,
)
{
    val from= remember { mutableStateOf("") }
    val until= remember { mutableStateOf("") }

    LaunchedEffect(selectedLoyaltyCard){
        until.value=""
        from.value=""
    }

    Column(
        modifier = Modifier
            .margin(top = Dimen.mediumPadding)
    )
    {
        MediumContentTitle(
            title = Strings.current().resetBooking,
        )

        Row(
            verticalAlignment = Alignment.CenterVertically
        )
        {
            CustomEditText(
                modifier = Modifier ,
                label = Strings.current().from,
                value = from.value,
                inputType = InputType.Number,
                defaultBorderColor = getCustomerCardSeriesBorderColor(
                    from=from.value,
                    until=until.value
                ),
                marginRight = Dimen.largePadding,
                isDecimal = true,
                width = Dimen.semiNormalEditTextWidth,
                marginBottom = Dimen.smallPadding,
                isRequired = false,
                hint = "",
                onFocusIn = {

                },
                onFocusOut = {},
                onInputChange = {it, validation ->
                    from.value=it
                },
            )


            CustomEditText(
                modifier = Modifier,
                label = Strings.current().until,
                inputType = InputType.Number,
                value =until.value,
                defaultBorderColor = getCustomerCardSeriesBorderColor(
                    from=from.value,
                    until=until.value
                ),
                width = Dimen.semiNormalEditTextWidth,
                marginRight = Dimen.normalPadding,
                isRequired = false,
                hint = "",
                marginBottom = Dimen.smallPadding,
                onFocusIn = {

                },
                onFocusOut = {},
                onInputChange = {it, validation ->
                    until.value=it
                },
            )
        }

        CustomButton(
            modifier = Modifier
                .margin(topBottom = Dimen.mediumPadding),
            loading = resetBookingLoading,
            isClickable = (from.value.isNotEmpty()
                    && until.value.isNotEmpty()
                    && from.value.toInt()<=until.value.toInt()
            ),
            title = Strings.current().resetBooking,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                resetRangeLoyaltyCard(
                    from.value.toInt(),
                    until.value.toInt(),
                )
            }

        )

    }



}